import React from "react";
import { useParams } from "react-router-dom";
import { useGetUserDetails, useSendInvite } from "../apiCalls/userApiCalls";
import { ArrowBackIos } from "@mui/icons-material";
import Loader from "../components/Loader";
import { useSelector } from "react-redux";

export default function UserDetails() {
  const { currentUser } = useSelector((state) => state.userSlice) || null;
  const token = currentUser.token;
  const { userId } = useParams();

  const { isLoading: isUserLoading, data: userDetails } = useGetUserDetails(
    userId,
    token
  );
  const {
    mutate: sendInviteMutate,
    isLoading: isSendInviteLoading,
    isError: isSendInviteError,
    error: sendInviteError,
  } = useSendInvite();

  const userEmail = userDetails?.data.data.email;

  const handleSendInvite = () => {
    const data = {
      token: token,
      email: userEmail,
    };
    sendInviteMutate(data);
  };

  const fallbackImage = "/images/avatar.jpg";

  return (
    <>
      {isUserLoading ? (
        <Loader />
      ) : (
        <>
          <div className="flex w-full items-center justify-center">
            <div className="mx-6 md:mx-32 lg:mx-44 xl:mx-64 mt-32 w-full lg:w-2/5">
              <div className="fixed lg:left-20 xl:left-32 mt-2 hidden lg:flex lg:items-center lg:justify-center items-center justify-center w-10 h-10 rounded-full bg-white shadow btn-shadow hover:shadow-s, hover:bg-stone-50 transition-colors">
                <button
                  onClick={() => window.history.back()}
                  className="w-full h-full rounded-full flex items-center justify-center"
                >
                  <ArrowBackIos
                    style={{ fontSize: 24, paddingLeft: 6, color: "gray" }}
                  />
                </button>
              </div>
              <div className="pt-10 flex flex-col gap-2 items-center">
                <form action="">
                  <div
                    className="w-28 h-28 border border-gray-200  rounded-full"
                    style={{
                      backgroundImage: `url("${userDetails.data.data.imgUrl}"), url("${fallbackImage}")`,
                      backgroundPosition: "center",
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat",
                    }}
                  ></div>
                </form>
                {(userDetails.data.data.role === "foreman" ||
                  userDetails.data.data.role === "worker") && (
                  <button
                    onClick={handleSendInvite}
                    className="flex h-full mt-2 text-center px-4 py-2 text-xs font-medium tracking-wide hover:scale-105 transition-all bg-[#59c3c2] hover:bg-teal-600 border border-gray-100 rounded-lg text-white"
                  >
                    Send Invite
                  </button>
                )}
              </div>

              <form className="pb-8">
                <div className="space-y-3 pt-8">
                  <div className="space-y-1">
                    <label
                      className="text-lg font-medium text-gray-500"
                      htmlFor=""
                    >
                      Name
                    </label>
                    <div className=" text-lg py-2 px-2 flex gap-2 border-b border-gray-500 ">
                      {userDetails.data.data.name}
                    </div>
                  </div>
                  <div className="space-y-1">
                    <label
                      className="text-lg font-medium text-gray-500"
                      htmlFor=""
                    >
                      Employee ID
                    </label>
                    <div className=" text-lg py-2 px-2 flex gap-2 border-b border-gray-500 ">
                      {userDetails.data.data.employeeCode}
                    </div>
                  </div>
                  <div className="space-y-1">
                    <label
                      className="text-lg font-medium text-gray-500"
                      htmlFor=""
                    >
                      Email Address
                    </label>
                    <div className=" py-4 px-5 flex gap-2 border-b  border-gray-500">
                      {userDetails.data.data.email}
                    </div>
                  </div>
                  <div className="space-y-1">
                    <label
                      className="text-lg font-medium text-gray-500"
                      htmlFor=""
                    >
                      Type
                    </label>
                    <div className=" py-4 px-5 flex gap-2 border-b capitalize border-gray-500">
                      {userDetails.data.data.role}
                    </div>
                  </div>
                  {userDetails.data.data.role === "foreman" && (
                    <>
                      <div className="space-y-1">
                        <label
                          className="text-lg font-medium text-gray-500"
                          htmlFor=""
                        >
                          Hourly Rate
                        </label>
                        <div className=" py-4 px-5 flex gap-2 border-b  border-gray-500">
                          {userDetails.data.data.hourlyRate}
                        </div>
                      </div>
                      <div className="space-y-1">
                        <label
                          className="text-lg font-medium text-gray-500"
                          htmlFor=""
                        >
                          Overtime Rate
                        </label>
                        <div className=" py-4 px-5 flex gap-2 border-b  border-gray-500">
                          {userDetails.data.data.overtimeRate}
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </form>

              {userDetails.data.data.workers.length > 0 && (
                <div className="space-y-3 pb-8">
                  <h1 className="text-2xl font-medium pb-4">
                    Assigned Workers
                  </h1>
                  {userDetails.data.data.workers.map((worker) => (
                    <>
                      <div
                        key={worker._id}
                        className="card hover:scale-105 transition-all ease-in-out bg-white card-shadow rounded-lg p-3"
                      >
                        <div className="flex gap-5 items-center py-2">
                          <div
                            className="w-16 h-16 border border-gray-200  rounded-full"
                            style={{
                              backgroundImage: `url("${worker.imgUrl}"), url("${fallbackImage}")`,
                              backgroundPosition: "center",
                              backgroundSize: "cover",
                              backgroundRepeat: "no-repeat",
                            }}
                          ></div>
                          <div className="desc -space-y-1">
                            <h2 className="text-lg font-medium tracking-wide">
                              {worker.name}
                            </h2>
                            <h2 className="text-lg font-light tracking-wide">
                              {worker.role}
                            </h2>
                          </div>
                        </div>
                      </div>
                    </>
                  ))}
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
}
